import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Table } from 'primeng/table';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { Tc } from '../../../core/_infrastructure/types/common';
import { TrailblazerService } from './trailblazer.service';
import { TrailblazerFilterSearchingViewModel, TrailblazerPagingResultViewModel } from './trailblazer.types';

@Component({
    selector: 'app-trailblazer-list',
    templateUrl: './trailblazer-list.component.html',
})
export class TrailblazerListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;
    trailblazerResult: TrailblazerPagingResultViewModel;
    cols: any[];
    listDataViews: Tc[];
    model: TrailblazerFilterSearchingViewModel;
    visibilitySpinner: boolean = false;

    public isCollapsed = false;

    constructor(
        private fb: UntypedFormBuilder,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        protected authService: AuthService,
        protected trailblazerService: TrailblazerService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.model = new TrailblazerFilterSearchingViewModel();
        this.model.ClauseCollection = new Array<string>();
    }

    ngOnInit() {
        this.form = this.fb.group({
            dataView: [null, Validators.required],
            Condicion: null,
        });

        this.trailblazerService.getDataViews().subscribe(res => {
            this.listDataViews = res;
        });
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.searchingButton = true;
        if (this.form.valid) this.isCollapsed = true;
    }

    Search(pageNumber: number, asc: number = 0, orderBy: string = '') {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.model.DataView = this.form.value.dataView;

        this.model.PageNumber = pageNumber;
        this.model.Asc = asc;
        this.model.OrderBy = orderBy;

        this.trailblazerService.postTrailblazerPagedByFilter(this.model).subscribe(s => {
            let result = s as TrailblazerPagingResultViewModel;

            this.cols = result.Result.Columns.map(x => ({ field: x.Field, header: x.Literal }));

            this.trailblazerResult = result;

            this.loading = false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;

        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    //onPaging(event: any)
    //{
    //    this.Search(event.page);
    //}

    onCleanButton() {
        this.form.setValue({
            dataView: null,
            Condicion: null,
        });

        this.model.ClauseCollection = new Array<string>();

        this.isCollapsed = false;
        this.searchingButton = false;
    }

    onAddCondicion() {
        this.removeValidators('Condicion');
        this.addValidator('Condicion', Validators.required);

        if (this.isFieldInvalidNoSubmit('Condicion', 'required')) {
            return;
        }

        this.removeValidators('Condicion');

        let condicion: string = this.form.value.Condicion;

        this.form.patchValue({
            Condicion: '',
        });

        this.model.ClauseCollection.push(condicion);
    }

    onDeleteCondicion(item: string) {
        this.model.ClauseCollection.splice(this.model.ClauseCollection.indexOf(item), 1);
    }

    onExportExcel() {
        this.visibilitySpinner = true;

        this.trailblazerService.export(this.model).subscribe(res => {
            this.OpenDownloadedFile(res);

            this.visibilitySpinner = false;
        });
    }
}
